<template>
  <div id="app">
    <Inquiry />
    <router-view/>
  </div>
</template>

<script>
import Inquiry from './common/Inquiry.vue'
export default {
  name: 'App',
  components: {
    Inquiry
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue